import { useSelector } from 'react-redux'

import { type Property, PropertyType, AttributeProperties } from 'api/clients/PropertyClient'
import { Condition } from '../Filter'
import type { RootState } from 'types'
import { attributeForDefaultProperty } from '../utils'

export const usePropertyForCondition = (condition: Condition): Property | undefined => {
  let property = useSelector(({ properties }: RootState) => {
    if (condition.operand.property_id) {
      return properties[condition.operand.property_id]
    }

    if (condition.operand.attribute) {
      return Object.values(properties).filter(
        (property) => attributeForDefaultProperty(property) === condition.operand.attribute,
      )[0]
    }
  })

  if (!property && condition.operand.kind === 'attribute' && condition.operand.attribute) {
    switch (condition.operand.attribute) {
      case PropertyType.Title:
        property = AttributeProperties.name
        break
      default:
        break
    }
  }

  return property
}
